"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserCookies = require('js-cookie');
function getCookie(key) {
    return BrowserCookies.get(key);
}
exports.getCookie = getCookie;
function updateCookie(key, value, options) {
    if (value) {
        BrowserCookies.set(key, value, options);
    }
    else {
        BrowserCookies.remove(key);
    }
}
exports.updateCookie = updateCookie;
//# sourceMappingURL=browserCookieWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-optin/lib/utils/browserCookieWrapper.js
// module id = 3021
// module chunks = 45 62